import { isBasket, isBottle, isCask } from '~/utils/product-item-type'
import { gettext } from '../i18n/catalog'
import { formatAsAmount, formatAsPercentage } from '../i18n/formatters'

const defaultOptions = { includeBatchName: true }

export function getProductName(
  { basketName, brandName, age, batchName, displayName, itemType },
  options = defaultOptions,
) {
  if (isBasket({ itemType })) {
    return basketName || displayName
  }

  let name = brandName

  if (isCask({ itemType }) && displayName) {
    name = displayName
  }

  if (age) {
    name += ' ' + age + getAgeSuffix()
  }
  if (options.includeBatchName && batchName) {
    name += ' ' + batchName
  }
  return name
}

export function getProductDescription(details) {
  if (details === null || details === undefined) {
    return ''
  }

  const {
    itemType,
    displayName,
    distillationYear,
    caskType,
    originalContent,
    batchName,
    brandName,
    age,
    yearDistilled,
    yearBottled,
    bottleryName,
    alcoholPercentage,
    region,
    volumeInMl,
  } = details

  if (isCask({ itemType })) {
    return [
      displayName,
      distillationYear ?? null,
      caskType ?? null,
      originalContent ?? null,
    ]
      .filter(Boolean)
      .join(' | ')
  }

  return [
    batchName ? batchName + ' ' + brandName : brandName,
    age ? age + getAgeSuffix() : null,
    yearDistilled && yearBottled ? yearDistilled + ' - ' + yearBottled : '',
    bottleryName ?? null,
    alcoholPercentage ? formatAsPercentage(alcoholPercentage) : null,
    region ?? null,
    volumeInMl ? formatAsAmount(volumeInMl) : null,
  ]
    .filter(Boolean)
    .join(' | ')
}

function getAgeSuffix() {
  return gettext('yo') // years ago shortened
}

export function getProductIdFromSlug(slug) {
  const slugParts = slug.split('-')

  // Last part of product slug is product id
  return slugParts.at(-1)
}

export function getProductImageUrl(articleDetails) {
  const { itemType, image, imageUrl, caskLogoUrl } = articleDetails

  return isBottle({ itemType })
    ? image
      ? image.fileName
      : imageUrl
    : caskLogoUrl
      ? caskLogoUrl.fileName
      : imageUrl
}
